import useAsyncData from "../../../hooks/use-async-data";
import taxiCorporationService from "../taxi-corporation.service";
import TaxiCorporationList from "./taxi-corporation-list";
import TaxiCorporationListParams from "./taxi-corporation-list-params";

const useTaxiCorporationList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiCorporationList>({ data: [], totalCount: 0 });

  const load = async (
    params: TaxiCorporationListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiCorporationList = await taxiCorporationService.getList(
        params,
        signal,
      );

      setData(taxiCorporationList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiCorporationList;
